import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */
const { Types, Creators } = createActions({
  // Requests actions
  requestAllAnnotations: [],
  requestLessonAnnotations: ['courseId', 'lessonId'],
  requestStoreAnnotation: ['courseId', 'lessonId', 'description'],
  requestUpdateAnnotation: [
    'courseId',
    'lessonId',
    'annotationId',
    'description',
  ],
  requestRemoveAnnotation: ['courseId', 'lessonId', 'annotationId'],
  // Handle store actions
  setAnnotations: ['annotations'],
  setAnnotationsFailure: ['errorData'],
  updateAnnotations: ['annotations'],
  removeAnnotation: ['annotationId'],
});
export const AnnotationsTypes = Types;
export default Creators;

/* Initial State */
export const INITIAL_STATE = Immutable({
  list: {},
  error: null,
  allLoaded: false,
});

const setAnnotations = (state = INITIAL_STATE, { annotations }) =>
  Immutable.merge(state, {
    list: annotations,
    allLoaded: true,
  });

const setAnnotationsFailure = (state = INITIAL_STATE, { errorData }) =>
  Immutable.set(state, ['error'], errorData);

const updateAnnotations = (state = INITIAL_STATE, { annotations }) =>
  Immutable.updateIn(state, ['list'], list =>
    Immutable.merge(list, annotations),
  );

const removeAnnotation = (state = INITIAL_STATE, { annotationId }) =>
  Immutable.updateIn(state, ['list'], list =>
    Immutable.without(list, annotationId),
  );

/* Reducers to types */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_ANNOTATIONS]: setAnnotations,
  [Types.SET_ANNOTATIONS_FAILURE]: setAnnotationsFailure,
  [Types.UPDATE_ANNOTATIONS]: updateAnnotations,
  [Types.REMOVE_ANNOTATION]: removeAnnotation,
});
